import type { Pilot, PilotClass } from '@/shared/types'
import { UNITS } from './units'

const FAMILY = ['Nguyễn', 'Trần', 'Lê', 'Phạm', 'Hoàng', 'Vũ', 'Đặng', 'Bùi', 'Đỗ', 'Phan', 'Hồ']
const MIDDLE = ['Văn', 'Hữu', 'Đức', 'Quang', 'Minh', 'Hoàng', 'Anh', 'Thanh', 'Xuân', 'Trung', 'Bá']
const GIVEN = ['Hùng', 'Dũng', 'Tuấn', 'Sơn', 'Long', 'Tùng', 'Hải', 'Nam', 'Phong', 'Bình', 'Khôi', 'Việt', 'Cường', 'Đạt', 'Thắng', 'Lâm', 'Vinh', 'Trí']

const RANKS = ['Đại tá', 'Thượng tá', 'Trung tá', 'Thiếu tá', 'Đại uý', 'Thượng uý', 'Trung uý']
const CLASSES: PilotClass[] = ['Cấp 1', 'Cấp 2', 'Cấp 3', 'Học viên']
const STATUSES: Pilot['status'][] = ['active', 'active', 'active', 'rest', 'training', 'medical']
const AIRCRAFT_TYPES = ['Su-30MK2', 'Su-22M4', 'Su-27SK', 'MiG-21Bis', 'Yak-130', 'L-39C', 'Mi-8', 'Mi-17', 'C-295M']
const COLORS = ['#1e6091', '#0e7490', '#15803d', '#a16207', '#7c3aed', '#be185d', '#0891b2', '#9333ea']

function pick<T>(arr: T[], idx: number): T {
  return arr[idx % arr.length]
}

function pad(n: number, w: number): string {
  return String(n).padStart(w, '0')
}

function generatePilots(): Pilot[] {
  const list: Pilot[] = []
  const trungDoanUnits = UNITS.filter((u) => u.level === 'trung-doan').slice(0, 10)

  trungDoanUnits.forEach((unit, uIdx) => {
    const count = 5 + (uIdx % 3)
    for (let i = 0; i < count; i++) {
      const idx = list.length
      const family = pick(FAMILY, idx * 3 + 1)
      const middle = pick(MIDDLE, idx * 7 + 2)
      const given = pick(GIVEN, idx * 11 + 5)
      const fullName = `${family} ${middle} ${given}`
      const pilotClass = pick(CLASSES, idx)
      const totalHours = pilotClass === 'Cấp 1' ? 2000 + (idx % 10) * 150 : pilotClass === 'Cấp 2' ? 1200 + (idx % 10) * 80 : pilotClass === 'Cấp 3' ? 600 + (idx % 10) * 50 : 200 + (idx % 10) * 30
      const numTypes = pilotClass === 'Cấp 1' ? 3 : pilotClass === 'Cấp 2' ? 2 : 1
      const types = Array.from({ length: numTypes }, (_, k) => pick(AIRCRAFT_TYPES, idx + k * 2))
      list.push({
        id: `p-${idx + 1}`,
        code: `PC-${pad(idx + 1, 4)}`,
        fullName,
        rank: pick(RANKS, idx),
        unitId: unit.id,
        birthYear: 1975 + (idx % 25),
        pilotClass,
        totalHours,
        hoursLast30Days: 8 + (idx % 25),
        aircraftTypes: Array.from(new Set(types)),
        status: pick(STATUSES, idx),
        lastFlightDate: `2026-04-${pad(((idx * 3) % 28) + 1, 2)}`,
        medicalExpiryDate: `2026-${pad(((idx + 4) % 12) + 1, 2)}-${pad(((idx * 7) % 28) + 1, 2)}`,
        avatarColor: pick(COLORS, idx),
      })
    }
  })

  return list
}

export const PILOTS: Pilot[] = generatePilots()
export const PILOTS_BY_ID: Record<string, Pilot> = Object.fromEntries(
  PILOTS.map((p) => [p.id, p]),
)
